<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center">Contents</h1>
<p class="toc2"><a href="#/v1/4chap1">Chapter 1: PETER BREAKS THROUGH</a></p>
<p class="toc1"><a href="#/v1/5chap2">Chapter 2: THE SHADOW</a></p>
<p class="toc1"><a href="#/v1/6chap3">Chapter 3: COME AWAY, COME AWAY!</a></p>
<p class="toc1"><a href="#/v1/7chap4">Chapter 4: THE FLIGHT</a></p>
<p class="toc1"><a href="#/v1/8chap5">Chapter 5: THE ISLAND COME TRUE</a></p>
<p class="toc1"><a href="#/v1/9chap6">Chapter 6: THE LITTLE HOUSE</a></p>
<p class="toc1"><a href="#/v1/10chap7">Chapter 7: THE HOME UNDER THE GROUND</a></p>
<p class="toc1"><a href="#/v1/11chap8">Chapter 8: THE MERMAIDS’ LAGOON</a></p>
<p class="toc1"><span href="#/v1/12chap9" title="Link target outside of Sample">Chapter 9: THE NEVER BIRD</span></p>
<p class="toc1"><span href="#/v1/13chap10" title="Link target outside of Sample">Chapter 10: THE HAPPY HOME</span></p>
<p class="toc1"><span href="#/v1/14chap11" title="Link target outside of Sample">Chapter 11: WENDY’S STORY</span></p>
<p class="toc1"><span href="#/v1/15chap12" title="Link target outside of Sample">Chapter 12: THE CHILDREN ARE CARRIED OFF</span></p>
<p class="toc1"><span href="#/v1/16chap13" title="Link target outside of Sample">Chapter 13: DO YOU BELIEVE IN FAIRIES?</span></p>
<p class="toc1"><span href="#/v1/17chap14" title="Link target outside of Sample">Chapter 14: THE PIRATE SHIP</span></p>
<p class="toc1"><span href="#/v1/18chap15" title="Link target outside of Sample">Chapter 15: “HOOK OR ME THIS TIME”</span></p>
<p class="toc1"><span href="#/v1/19chap16" title="Link target outside of Sample">Chapter 16: THE RETURN HOME</span></p>
<p class="toc1"><span href="#/v1/20chap17" title="Link target outside of Sample">Chapter 17: WHEN WENDY GREW UP</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3TOC.vue?683d981d